const e={display:"flex",justifyContent:"center",alignItems:"center"};export{e as flexCenter};
